export default class ApiClientError {
	code: string;

	title: string;

	details: string | null;

	source: { pointer: string | null; parameter?: string | null } | null;

	meta: { [key in string]: any };

	constructor(
		code: string,
		title: string,
		details: string | null = null,
		source: { pointer: string | null; parameter?: string | null } | null = null,
		meta: { [key in string]: any } = {}
	) {
		this.code = code;
		this.title = title;
		this.details = details;
		this.source = source;
		this.meta = meta;
	}
}
